export enum CognitoErrorCodesEnum {
	USER_NOT_CONFIRMED = 'USER_NOT_CONFIRMED',
	INVALID_EMAIL_OR_PASSWORD = 'INVALID_EMAIL_OR_PASSWORD',
	USER_NOT_FOUND = 'USER_NOT_FOUND',
	GENERIC_ERROR = 'GENERIC_ERROR',
	CODE_MISMATCH = 'CODE_MISMATCH',
	EXPIRED_CODE = 'EXPIRED_CODE',
	USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
	MISSING_COOKIE = 'MISSING_COOKIE',
	UNAUTHORIZED = 'UNAUTHORIZED',
	PASSWORD_RESET_REQUIRED = 'PASSWORD_RESET_REQUIRED',
}

export enum QueryParamsErrorCodesEnum {
	UNAUTHORIZED = 'unauthorized',
}

export enum OAuthProviderEnum {
	GOOGLE = 'google',
	MICROSOFT = 'microsoft',
	APPLE = 'apple',
	YAHOO = 'yahoo',
}

export enum PlatformsEnum {
	BO = 'backoffice',
	CONSUMER = 'consumer',
}
